export enum LeadGenerationEnum {
  HELP = 'help',
}
